<button
    *ngIf="type === 'stroked'"
    [ngClass]="{ 'button-highlight': highlight }"
    class="stroked-button"
    mat-stroked-button
    (click)="buttonClick.emit($event)"
    [disabled]="disabled"
    [matTooltip]="tooltip"
>
    <ng-container *ngTemplateOutlet="buttonContent" />
</button>

<button
    *ngIf="type === 'flat'"
    [ngClass]="{ danger: color === 'danger', 'button-highlight': highlight }"
    class="flat-button"
    mat-flat-button
    (click)="buttonClick.emit($event)"
    [disabled]="disabled"
    [matTooltip]="tooltip"
>
    <ng-container *ngTemplateOutlet="buttonContent" />
</button>

<button
    *ngIf="type === 'icon'"
    [ngClass]="{ 'button-highlight': highlight }"
    class="icon-button"
    mat-icon-button
    (click)="buttonClick.emit($event)"
    [disabled]="disabled"
    [matTooltip]="tooltip"
>
    <i class="fas fa-fw {{ icon }}"></i>
</button>

<button
    *ngIf="type === 'text'"
    [ngClass]="{ 'button-highlight': highlight }"
    class="text-button"
    mat-button
    (click)="buttonClick.emit($event)"
    [disabled]="disabled"
    [matTooltip]="tooltip"
>
    <ng-container *ngTemplateOutlet="buttonContent" />
</button>

<ng-template #buttonContent>
    <span class="is-flex align-center button-content">
        <span
            *ngIf="icon && iconPos === 'before'"
            class="button-icon"
        >
            <i
                *ngIf="!isLoading"
                class="fas fa-fw {{ icon }}"
            ></i>
            <mat-spinner
                *ngIf="isLoading"
                [diameter]="15"
            ></mat-spinner>
        </span>
        <span class="text">
            {{ buttonText }}
        </span>
        <span
            *ngIf="icon && iconPos === 'after'"
            class="button-icon"
        >
            <i
                *ngIf="!isLoading"
                class="fas fa-fw {{ icon }}"
            ></i>
            <mat-spinner
                *ngIf="isLoading"
                [diameter]="15"
            ></mat-spinner>
        </span>
    </span>
</ng-template>
